export default createLangFilter;

/**
 * Should generate
 * @param {string} lang
 */
function createLangFilter(lang) {
  const matcher = new RegExp(`^${lang}`);
  /**
   * @param {Subtitle} subtitle
   * @return {boolean}
   */
  return subtitle => matcher.test(subtitle.lang_iso_639_1) || matcher.test(subtitle.lang_tag);
}
